import React from 'react';
import { Select } from 'antd';
const {Option} = Select;
import cuid from '@paralleldrive/cuid2';
// self
import './index.less';
import { IForecastChartOrTableModel,
    ITemplateOptionsDetailResModel,
    ITemplateOptionsResModel } from '@/util/Request/agrialert/requestType';
import { AgriAlertClostIcon } from '@/resource/IconComponentSets';
import { AgregationEnum, ChartsOrTablesEnum, ForecastDays } from '@/page/Agrialert/template-management/template-management';

const ChangeTypeEnum = {
    AGGREGATION: 'Aggregation',
    CHARTSVARIABLES: 'Variables',
    FORECASTDAYS: 'ForecastDays'
};

interface IProp{
    templateOptions: ITemplateOptionsResModel;
    isDisabled: boolean;
    selectedForecast: IForecastChartOrTableModel[];
    type: string;
    childChangeSelectedForecast?: (updateFn?:any)=>void
}


const ForecastSelect = (prop:IProp)=>{

    const {
        templateOptions,
        isDisabled,
        selectedForecast,
        type,
        childChangeSelectedForecast
    } = prop;

    const publicChangeHistoricalItems = (index: number,type: string,
        aggregationValue?: string, chartVariables?: string[],forecastDays?: number)=>{

        childChangeSelectedForecast((draft) => {
            if (type === ChangeTypeEnum.AGGREGATION && aggregationValue !== undefined) {
                draft[index].aggregation = aggregationValue;
                draft[index].variablesForArray = [];
                draft[index].variables = null;
            } else if (type === ChangeTypeEnum.CHARTSVARIABLES && chartVariables !== undefined) {
                draft[index].variablesForArray = chartVariables;
                draft[index].variables = chartVariables.join(';');
            }
            else if(type === ChangeTypeEnum.FORECASTDAYS){
                draft[index].forecastDays = forecastDays;
            }
        });
    };

    const addHistoricalChartItem = ()=>{
        const tmpHistoricalChartsItem: IForecastChartOrTableModel = {
            sortNumber: selectedForecast?.length,
            aggregation: null,
            variables: null,
            variablesForArray: []
        };
        childChangeSelectedForecast(draft =>{
            draft.push(tmpHistoricalChartsItem); // 添加新的数据
        });

    };

    const deleteHistoricalChartItem = (index:number)=>{
        childChangeSelectedForecast(draft => {
            if (draft.length === 1 && index === 0) {
                draft[0] = {
                    sortNumber: 0,
                    aggregation: null,
                    variables: null,
                    variablesForArray: []
                };
            } else {
                // 移除指定索引的项目并重新索引剩余项目
                draft.splice(index, 1);
                draft.forEach((item, idx) => {
                    item.sortNumber = idx; // 更新 sortNumber 以反映新的顺序
                });
            }
        });

    };



    return(
        <div className='historicalChartSelect-all-container'>
            <div className='historicalChartSelect-container'>
                {
                    selectedForecast?.map((item,index)=>{
                        // 动态确定 Select Variables 的数据源
                        let variableOptions:ITemplateOptionsDetailResModel[] = templateOptions?.forecastWeatherDailyVariables;
                        if (item?.aggregation === AgregationEnum.DAILY) {
                            if(type === ChartsOrTablesEnum.CHARTS){
                                variableOptions = templateOptions?.forecastWeatherDailyVariables?.filter(x => x?.forecast_request_code!== 'WindDirection_DailyAvg');
                            }
                            else if(type === ChartsOrTablesEnum.TABLES){
                                variableOptions = templateOptions?.forecastWeatherDailyVariables?.filter(x =>
                                    x?.forecast_request_code!== 'WindDirection_DailyAvg (Deg)' &&
                                    x?.forecast_request_code !== 'PictoCode_Daily');
                            }
                            // variableOptions = templateOptions?.forecastWeatherDailyVariables;
                        } else if (item?.aggregation === AgregationEnum.EIGHTHOURLY) {
                            if(type === ChartsOrTablesEnum.CHARTS){
                                variableOptions = templateOptions?.forecastWeatherEightHourlyVariables?.filter(x => x?.forecast_request_code!== 'WindDirection_8HourlyAvg');
                            }
                            else if(type === ChartsOrTablesEnum.TABLES){
                                variableOptions = templateOptions?.forecastWeatherEightHourlyVariables?.filter(x =>
                                    x?.forecast_request_code!== 'WindDirection_8HourlyAvg (Deg)' &&
                                    x?.forecast_request_code !== 'PictoCode_8Hourly');
                            }
                        }
                        else if (item?.aggregation === AgregationEnum.HOURLY){
                            if(type === ChartsOrTablesEnum.CHARTS){
                                variableOptions = templateOptions?.forecastWeatherHourlyVariables?.filter(x => x?.forecast_request_code!== 'WindDirection_Hourly');
                            }
                            else{
                                variableOptions = templateOptions?.forecastWeatherHourlyVariables;
                            }
                        }
                        return(
                            <>
                                <div
                                    className='historicalChartSelect-content-item'
                                    key = {cuid.createId()}
                                >
                                    <div className='item-content'>
                                        <div className='flex-row'>
                                            <div className='select-aggregation'>
                                                <p><span className='red'>*</span>Select Aggregation</p>
                                                <Select
                                                    size='large'
                                                    placeholder='Select Aggregation'
                                                    value={item?.aggregation || null}
                                                    onChange={(e)=>{
                                                        publicChangeHistoricalItems(index,ChangeTypeEnum.AGGREGATION,e,null,null);
                                                    }}
                                                    disabled={isDisabled}
                                                >
                                                    {
                                                        templateOptions?.forecastWeatherAggregation?.sort((a,b)=>{
                                                            if(a.name < b.name) return -1;
                                                            if(a.name > b.name) return 1;
                                                            return 0;
                                                        })?.map((optionItem)=>{
                                                            return(
                                                                <>
                                                                    <Option
                                                                        key={cuid.createId()}
                                                                        value = {optionItem?.code?.toString()}
                                                                    >
                                                                        {optionItem?.name}
                                                                    </Option>
                                                                </>
                                                            );
                                                        })
                                                    }
                                                </Select>
                                            </div>
                                            <div className='select-variables'>
                                                <p><span className='red'>*</span>Select Variables</p>
                                                <Select
                                                    disabled={isDisabled}
                                                    className='multiple-select'
                                                    placeholder="Select Variables"
                                                    size='large'
                                                    mode="multiple"
                                                    value={item?.variablesForArray || []}
                                                    onChange={(e)=>{
                                                        publicChangeHistoricalItems(index,ChangeTypeEnum.CHARTSVARIABLES,null,e,null);
                                                    }}
                                                >
                                                    {variableOptions?.sort((a,b)=>{
                                                        if(a.name < b.name) return -1;
                                                        if(a.name > b.name) return 1;
                                                        return 0;
                                                    })?.map((item,index) => (
                                                        <Option
                                                            key = {cuid.createId()}
                                                            value={item?.forecast_request_code}>
                                                            {item.name}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>
                                        </div>
                                        <div className='flex-row'>
                                            <div className='select-aggregation'>
                                                <p><span className='red'>*</span>Select Days</p>
                                                <Select
                                                    size='large'
                                                    placeholder='Select Aggregation'
                                                    value={item?.forecastDays || 7}
                                                    onChange={(e)=>{
                                                        publicChangeHistoricalItems(index,ChangeTypeEnum.FORECASTDAYS,null,null,e);
                                                    }}
                                                    disabled={isDisabled}
                                                >
                                                    {
                                                        ForecastDays?.map((item)=>{
                                                            return(
                                                                <>
                                                                    <Option
                                                                        key={cuid.createId()}
                                                                        value = {item }
                                                                    >
                                                                        {`${item} ${item > 1 ? ' days' : ' day'}`}
                                                                    </Option>
                                                                </>
                                                            );
                                                        })
                                                    }
                                                </Select>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className='delete-agronomic'
                                        style={{marginTop: '10px'}}
                                        onClick={()=>{
                                            deleteHistoricalChartItem(index);
                                        }}
                                    >
                                        <AgriAlertClostIcon/>
                                    </div>
                                </div>
                            </>
                        );
                    })
                }

            </div>


            <div className='agronomic-add-button-container'>
                <button
                    className='add-recommendation-button'
                    onClick={()=>{
                        addHistoricalChartItem();
                    }}
                >+ Add another Forecast {type}</button>
            </div>

        </div>
    );
};

export default ForecastSelect;